import { NotFoundPage } from '@scoring/ui';
import { Navigate, Route } from 'react-router';
import { lazyPage } from '../../shell/lazyPage';
import { AdminRoute } from './AdminRoute';

const AuditsPage = lazyPage(() => import('./features/admin/audits/AuditsPage.tsx'), 'AuditsPage');
const UsersPage = lazyPage(() => import('./features/admin/users/UsersPage.tsx'), 'UsersPage');
const AthletesPage = lazyPage(() => import('./features/athletes/athletes/AthletesPage.tsx'), 'AthletesPage');
const AthletesStreaming = lazyPage(() => import('./features/athletes/athletesStreaming.tsx'), 'AthletesStreaming');
const OrganisationsPage = lazyPage(
    () => import('./features/athletes/organisations/OrganisationsPage.tsx'),
    'OrganisationsPage'
);
const CategoryPage = lazyPage(() => import('./features/events/categories/CategoryPage.tsx'), 'CategoryPage');
const CompetitionPage = lazyPage(() => import('./features/events/competitions/CompetitionPage.tsx'), 'CompetitionPage');
const EventPage = lazyPage(() => import('./features/events/events/EventPage.tsx'), 'EventPage');
const EventsPage = lazyPage(() => import('./features/events/events/EventsPage.tsx'), 'EventsPage');
const EventStructureOutlet = lazyPage(
    () => import('./features/events/EventStructureOutlet.tsx'),
    'EventStructureOutlet'
);
const HeatPage = lazyPage(() => import('./features/events/heats/HeatPage.tsx'), 'HeatPage');
const PhasePage = lazyPage(() => import('./features/events/phases/PhasePage.tsx'), 'PhasePage');
const UnitPage = lazyPage(() => import('./features/events/units/UnitPage.tsx'), 'UnitPage');
const ScoreManagerPage = lazyPage(() => import('./features/score-manager/ScoreManagerPage.tsx'), 'ScoreManagerPage');
const SeriesPage = lazyPage(() => import('./features/series/SeriesPage.tsx'), 'SeriesPage');
const SeriesStreaming = lazyPage(() => import('./features/series/SeriesStreaming.tsx'), 'SeriesStreaming');
const DashboardPage = lazyPage(() => import('./features/dashboard/DashboardPage.tsx'), 'DashboardPage');

export const managerRoutes = (
    <Route path="manager" lazy={DashboardPage}>
        <Route index element={<Navigate to="/manager/events" replace />} />
        <Route path="global" lazy={AthletesStreaming}>
            <Route index element={<Navigate to="/manager/global/athletes" replace />} />
            <Route path="athletes" lazy={AthletesPage} />
            <Route path="organisations" lazy={OrganisationsPage} />
        </Route>
        <Route path="events">
            <Route index lazy={EventsPage} />
            <Route path=":externalId" lazy={EventStructureOutlet}>
                <Route index lazy={EventPage} />
                <Route
                    path="score-manager/:competitionExternalId?/:categoryExternalId?/:phaseExternalId?/:heatExternalId?"
                    lazy={ScoreManagerPage}
                />
                <Route path=":competitionExternalId" lazy={CompetitionPage} />
                <Route path=":competitionExternalId/:categoryExternalId" lazy={CategoryPage} />
                <Route path=":competitionExternalId/:categoryExternalId/:phaseExternalId" lazy={PhasePage} />
                <Route
                    path=":competitionExternalId/:categoryExternalId/:phaseExternalId/:heatExternalId"
                    lazy={HeatPage}
                />
                <Route
                    path=":competitionExternalId/:categoryExternalId/:phaseExternalId/:heatExternalId/:unitExternalId"
                    lazy={UnitPage}
                />
            </Route>
        </Route>

        <Route path="series" lazy={SeriesStreaming}>
            <Route index lazy={SeriesPage} />
        </Route>

        <Route path="admin" element={<AdminRoute />}>
            <Route path="users" lazy={UsersPage} />
            <Route path="audits" lazy={AuditsPage} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
    </Route>
);
